module.exports = __webpack_public_path__ + "static/img/scene3.9fd11caa.jpg";